import {
  Button,
  CircularProgress,
  Grid,
  Pagination,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import MiniDrawer from "../../Components/Drawer";
import BaseColor from "../../Config/Color";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { getApiData } from "../../Apis/apiHelper";
import BaseSetting from "../../Apis/setting";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { FontFamily } from "../../Config/theme";
import CInput from "../../Components/CInput";
import _ from "lodash";
import {
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CButton from "../../Components/CButton";

const EditTranslation = () => {
  const [pageLoad, setPageLoad] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [translateTemplateData, settranslateTemplateData] = useState([]);
  const [pagination, setPagination] = useState();
  const [translationData, setTranslationData] = useState([]);
  const [dataLoader, setDataLoader] = useState(false);
  const [updateWithGoogleBtnLoading, setUpdateWithGoogleBtnLoading] =
    useState(false);

  const searchRef = useRef();
  const dataGridRef = useRef();
  const getDataGridApi = (api) => {
    dataGridRef.current = api;
  };

  const [changeId, setChangeId] = useState(true);

  const [inputId, setInputId] = useState("");
  const [inputVal, setInputVal] = useState("");

  const [eVal, seteVal] = useState("");

  const { language_id } = useParams();

  // search and sort
  const [searchVal, setSearchVal] = useState("");
  const [rowChange, setRowChange] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setPageLoad(true);
    getAlltranslateTemplateApiCall(pageNo, search, sortVal, sortByVal);
  }, []);

  useEffect(() => {
    setHeaderParams(page, search, sortVal, sortByVal, languageName);
    setTimeout(() => {
      setRowChange(true);
    }, 500);
  }, []);

  const [searchParams, setSearchParams] = useSearchParams();

  const isPage = searchParams.get("page");
  const page = isPage > 1 ? Number(isPage) : 1;
  const search = searchParams.has("search") ? searchParams.get("search") : "";
  const sortVal = searchParams.has("sort") ? searchParams.get("sort") : "";
  const languageName = searchParams.has("lang_name")
    ? searchParams.get("lang_name")
    : "";

  const sortByVal = searchParams.has("sort_by")
    ? searchParams.get("sort_by")
    : "";

  const setHeaderParams = (
    page,
    search = "",
    sort = "",
    sortBy = "",
    lang_name = ""
  ) => {
    const params = {
      page: page,
    };

    setPageNo(page);
    if (!_.isEmpty(search)) {
      setSearchVal(search?.trim());
    }
    if (!_.isEmpty(search)) {
      params.search = search;
    }
    if (!_.isEmpty(sort)) {
      params.sort = sort;
    }
    if (!_.isEmpty(sortBy)) {
      params.sort_by = sortBy;
    }
    if (!_.isEmpty(lang_name)) {
      params.lang_name = lang_name;
    }
    setSearchParams(createSearchParams(params));
  };

  //all translate template data
  const getAlltranslateTemplateApiCall = (page, search, sort, sortBy) => {
    const data = {
      page: page,
      type: "admin",
      lang_id: language_id,
    };

    if (!_.isEmpty(search)) {
      data.searchVal = search?.trim();
    }

    if (!_.isEmpty(sort)) {
      data.sort = sort;
    }

    if (!_.isEmpty(sortBy)) {
      data.sort_by = sortBy;
    }

    getApiData(BaseSetting.endpoint.getLanguageDatabase, "post", data)
      .then((result) => {
        if (result?.status) {
          const response = result?.data;
          if (!isEmpty(response)) {
            settranslateTemplateData(response?.languageData);
            setPagination(response?.pagination);
          }
          //   toast(result?.message, { type: "success" });
          setTimeout(() => {
            setDataLoader(false);
            setPageLoad(false);
          }, 100);
        } else {
          toast(result?.message, { type: "error" });
          setPageLoad(false);
          setDataLoader(false);
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
        setPageLoad(false);
        setDataLoader(false);
      });
  };

  const updateWithGoogle = () => {
    setUpdateWithGoogleBtnLoading(true);
    const endpoint = BaseSetting.endpoint.autoUpdateWithgoogle;
    getApiData(endpoint, "post", { lang_id: language_id })
      .then((result) => {
        if (result?.status) {
          toast(result?.message, { type: "success" });
          setUpdateWithGoogleBtnLoading(false);
        } else {
          toast(result?.message, { type: "error" });
          setUpdateWithGoogleBtnLoading(false);
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
        setUpdateWithGoogleBtnLoading(false);
      });
  };

  const handleUpdateValue = (ids, e) => {
    const updatedData = {
      id: ids,
      value: e,
      lang_id: language_id,
    };
    const endpoint = BaseSetting.endpoint.updateTranslationValue;
    getApiData(endpoint, "post", updatedData)
      .then((result) => {
        if (result?.status) {
          toast(result?.message, { type: "success" });
          getAlltranslateTemplateApiCall(pageNo, true);
          setChangeId(true);
          setInputId("");
        } else {
          toast(result?.message, { type: "error" });
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
      });
  };
  const translateTemplateColumn = [
    {
      field: "id",
      headerName: "NO.",
      flex: 0.2,
      minWidth: 70,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        const newStartIndex = (pageNo - 1) * pagination?.defaultPageSize + 1;
        translateTemplateData.map((data, i) => {
          data.serialNumber =
            params.api.getRowIndexRelativeToVisibleRows(params.row.id) +
            newStartIndex;
        });

        return (
          <Typography style={{ fontFamily: FontFamily.SemiBold }}>
            {params?.row?.serialNumber}
          </Typography>
        );
      },
    },
    {
      field: "message",
      headerName: "SOURCE",
      minWidth: 200,
      flex: 3,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "translation",
      headerName: "TRANSLATION",
      flex: 3,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        const translationIndex = translationData.findIndex(
          (item) => item.id === params.row.id
        );

        const handleInputChange = (e) => {
          setChangeId(false);
          setInputId(params.row.id);
          const newValue = e;
          seteVal(e);
          if (translationIndex !== -1) {
            const updatedTranslationData = [...translationData];
            updatedTranslationData[translationIndex].value = newValue;
            setTranslationData(updatedTranslationData);
          } else {
            setTranslationData((prevData) => [
              ...prevData,
              { id: params.row.id, value: newValue },
            ]);
          }
        };

        return (
          <CInput
            value={
              translationIndex !== -1 && translationData[translationIndex]
                ? translationData[translationIndex].value
                : params.row.translation
            }
            onChange={handleInputChange}
            onBlur={
              inputId.length === 0
                ? null
                : inputVal === eVal
                ? null
                : (e) => {
                    handleUpdateValue(params.row.id, e.target.value);
                  }
            }
            onFocus={(e) => {
              setInputVal(e.target.value);
              setChangeId(true);
              setInputId("");
            }}
            onKeyDown={(e) => {
              if (e.key === " " || e.code === "Space") {
                e.stopPropagation();
              }
            }}
          />
        );
      },
    },
    {
      field: "action",
      headerName: "ACTIONS",
      width: 150,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Grid container alignItems={"center"} justifyContent={"center"}>
            <Grid item>
              <Tooltip title="Save" placement="top" arrow>
                <Button
                  disabled={
                    inputId.length === 0
                      ? changeId
                      : params.row.id !== inputId
                      ? true
                      : eVal === inputVal
                  }
                  variant="contained"
                  // onClick={() => {
                  //   handleUpdateValue(params.row.id, eVal);
                  // }}
                >
                  SAVE
                </Button>
              </Tooltip>
            </Grid>
          </Grid>
        );
      },
    },
  ];
  return (
    <Grid container>
      <MiniDrawer
        header="Edit Translation"
        children={
          <>
            <Grid justifyContent={"space-between"} container>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  variant="contained"
                  onClick={() => navigate("/translate-page")}
                >
                  <ArrowBackIcon /> Back
                </Button>
                <div
                  style={{
                    border: `2px solid ${BaseColor.primary}`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "5px 15px",
                    borderRadius: "10px",
                    marginLeft: "30px",
                  }}
                >
                  Language name: {languageName}
                </div>
              </div>

              <div style={{ display: "flex" }}>
                {!_.isEmpty(search) ||
                !_.isEmpty(sortVal) ||
                !_.isEmpty(sortByVal) ? (
                  <Button
                    variant="contained"
                    onClick={() => {
                      setSearchVal("");
                      setHeaderParams(page, "", "", "");
                      getAlltranslateTemplateApiCall(1, "", "", "");
                      setDataLoader(true);
                      if (dataGridRef.current) {
                        dataGridRef.current.setFilterModel({
                          items: [],
                          quickFilter: "",
                        });
                      }
                    }}
                  >
                    Clear filters
                  </Button>
                ) : null}
                <CButton
                  loading={updateWithGoogleBtnLoading}
                  variant="contained"
                  onClick={updateWithGoogle}
                  btnStyle={{ minWidth: "300px" }}
                >
                  Auto Update With Google
                </CButton>
              </div>
            </Grid>

            <Grid container mt={"30px"}>
              {pageLoad ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "50vh",
                  }}
                >
                  <CircularProgress
                    style={{ color: BaseColor.primary }}
                    size={30}
                  />
                </div>
              ) : (
                <DataGrid
                  sortModel={
                    sortByVal === "asc" || sortByVal === "desc"
                      ? [
                          {
                            field: sortVal,
                            sort: sortByVal,
                          },
                        ]
                      : []
                  }
                  rows={translateTemplateData}
                  columns={translateTemplateColumn}
                  disableColumnMenu
                  disableDensitySelector
                  loading={dataLoader}
                  hideFooter
                  showCellVerticalBorder={true}
                  showColumnVerticalBorder={true}
                  disableSelectionOnClick
                  onSortModelChange={(model) => {
                    setDataLoader(true);
                    if (!_.isEmpty(model)) {
                      setHeaderParams(
                        page,
                        search,
                        model[0]?.field,
                        model[0].sort,
                        languageName
                      );
                      getAlltranslateTemplateApiCall(
                        page,
                        search,
                        model[0]?.field,
                        model[0].sort
                      );
                    } else {
                      setHeaderParams(page, search, "", "", languageName);
                      getAlltranslateTemplateApiCall(page, search, "", "");
                    }
                  }}
                  // onFilterModelChange={() => {
                  //   getAlltranslateTemplateApiCall(pageNo);
                  //   setDataLoader(true);
                  // }}
                  initialState={{
                    filter: {
                      filterModel: {
                        items: [],
                        quickFilterValues: [searchVal],
                      },
                    },
                  }}
                  disableColumnFilter
                  disableColumnSelector
                  apiRef={getDataGridApi}
                  sortingMode="server"
                  disableRowSelectionOnClick
                  autoHeight={true}
                  getRowHeight={() => "auto"}
                  slots={{ toolbar: GridToolbar }}
                  slotProps={{
                    toolbar: {
                      printOptions: { disableToolbarButton: true },
                      csvOptions: { disableToolbarButton: true },
                      showQuickFilter: true,
                      onChange: (e) => {
                        setDataLoader(true);
                        setSearchVal(e.target.value?.toLowerCase());
                        setHeaderParams(
                          1,
                          e?.target?.value?.toLowerCase(),
                          sortVal,
                          sortByVal,
                          languageName
                        );
                        if (searchRef.current) clearTimeout(searchRef.current);
                        searchRef.current = setTimeout(() => {
                          getAlltranslateTemplateApiCall(
                            1,
                            e?.target?.value?.toLowerCase(),
                            sortVal,
                            sortByVal
                          );
                        }, 800);
                      },
                    },
                  }}
                />
              )}
            </Grid>
            {!isEmpty(translateTemplateData) && (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Pagination
                  count={pagination?.totalPage}
                  page={page}
                  siblingCount={2}
                  onChange={(e, value) => {
                    getAlltranslateTemplateApiCall(
                      value,
                      search,
                      sortVal,
                      sortByVal
                    );
                    setHeaderParams(
                      value,
                      search,
                      sortVal,
                      sortByVal,
                      languageName
                    );
                    setPageLoad(true);
                    setPageNo(value);
                  }}
                  sx={{ display: pageLoad ? "none" : "block" }}
                />
              </div>
            )}
          </>
        }
      />
    </Grid>
  );
};

export default EditTranslation;
